/**
 * Module dependencies.
 */

import { IdCopy } from 'app/components/atoms/id-copy/id-copy';
import { User } from 'app/types/user';
import React from 'react';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  item: User;
};

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  min-width: 400px;
`;

/**
 * `Id` styled component.
 */

const Id = styled.div`
  flex: 0.2;
  flex-shrink: 0;
`;

/**
 * `Name` styled component.
 */

const Name = styled.div`
  flex: 0.6 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; /* opcional */
`;

/**
 * `PhoneNumber` styled component.
 */

const PhoneNumber = styled.div`
  flex: 0.2;
  flex-shrink: 0;
`;

/**
 * Export `RenderUserItem` component.
 */

export function RenderUserItem({ item }: Props): JSX.Element {
  return (
    <Wrapper>
      <Id>
        <IdCopy>{item.id}</IdCopy>
      </Id>

      <Name>{item.name}</Name>

      <PhoneNumber>{item.phoneNumber}</PhoneNumber>
    </Wrapper>
  );
}

/**
 * Export `RenderUserItemList` component .
 */

export function RenderUserItemList({ item }: { item: User }): JSX.Element {
  return (
    <Wrapper>
      <Name>{item.name}</Name>

      <PhoneNumber>{item.phoneNumber}</PhoneNumber>
    </Wrapper>
  );
}
